import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(
    private http: HttpClient
  ) { }
  public productId = "";
  public action = "";
  public _TherapyId = "";
  public _TherapyAction = "";
  private options = { headers: new HttpHeaders().set('isUpload', 'true') };

  GetAllProductDetails(){
    return this.http.get(environment.apiURL+`product/GetAllProductDetails?IsActive=true`);
  }
  GetAllProductDetailsByCreatedDate(date){
    return this.http.get(environment.apiURL + `product/GetAllProductDetails?IsActive=true&CreatedOn=`+date);
  }
  GetAllProductDetailsByDateWise(fromdate,todate){
    return this.http.get(environment.apiURL + `product/GetAllProductDetails?IsActive=true&FromDate=`+fromdate+`&ToDate=`+todate);
  }
  GetProductDetailsById(productId){
    return this.http.get(environment.apiURL + `product/GetAllProductDetails?_id=`+productId);
  }
  GetCompanyNames(){
    return this.http.get(environment.apiURL + `company/GetCompany?Isactive=true`);
  }
  GetIndication(){
    return this.http.get(environment.apiURL+`master/GetIndication`);
  }
  AddProduct(data){
    return this.http.post(environment.apiURL + `product/AddProduct`, data);
  }
  UpdateProduct(data){
    return this.http.post(environment.apiURL + `product/UpdateProduct`, data);
  }
  DeleteProduct(data){
    return this.http.post(environment.apiURL + `product/DeleteProduct`, data);
  }
  GetUserProduct(data){
    return this.http.post(environment.apiURL + `product/GetUserProduct`, data);
  }
  GetROA(){
    return this.http.get(environment.apiURL+`master/GetROA`);
  }
  GetCurrentPhase(){
    return this.http.get(environment.apiURL+`master/GetCurrentPhase`);
  }

  GetAllTheraphyDetails(){
    return this.http.get(environment.apiURL+`product/GetAllTheraphyDetails?IsActive=true`);
  }

  AddTheraphyInsight(data) {
    return this.http.post(environment.apiURL + `product/AddTheraphy`, data);
  }
  GetTheraphyInsightDetails(id) {
    return this.http.get(environment.apiURL + `product/GetAllTheraphyDetails?_id=` + id);
  }
  UpdateTheraphyInsight(data) {
    return this.http.post(environment.apiURL + `product/UpdateTheraphy`, data);
  }
  DeleteTheraphyInsight(data) {
    return this.http.post(environment.apiURL + `product/DeleteTheraphy`, data);
  }
  UploadTheraphyInsightAttachment(formData){    
    return this.http.post(environment.apiURL + `product/UploadTheraphyAttachment`, formData, this.options);
  }
  DeleteTheraphyAttachment(data) {
    return this.http.post(environment.apiURL + `product/DeleteTheraphyAttachment`, data);
  }
}
